/* eslint-disable react/static-property-placement */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import classNames from 'classnames';

import css from './RadioGroup.less';

class RadioGroupField extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    field: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.any,
    }).isRequired,
    form: PropTypes.shape({
      setFieldValue: PropTypes.func,
      touched: PropTypes.shape({}),
      errors: PropTypes.shape({}),
    }).isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    inline: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    lightLabel: PropTypes.bool,
  };

  static defaultProps = {
    inline: false,
    onChange: () => undefined,
    disabled: false,
    lightLabel: false,
  };

  hanleChange = (e, { value }) => {
    const {
      field: { name },
      form: { setFieldValue },
      onChange,
    } = this.props;
    setFieldValue(name, value);
    onChange(value);
  };

  render() {
    const {
      label,
      field: { name, value },
      form: { touched, errors },
      items = [],
      inline,
      disabled,
      lightLabel,
    } = this.props;

    return (
      <Form.Field>
        {label && <label className={classNames({ [css.customLabel]: lightLabel })}>{label}</label>}
        <Form.Group grouped={!inline} inline={inline}>
          {items.map(item => (
            <Form.Radio
              key={item.key}
              label={item.email ? `${item.label} (${item.email})` : `${item.label}`}
              name={name}
              value={item.value}
              checked={item.value === value}
              onChange={this.hanleChange}
              disabled={disabled}
            />
          ))}
        </Form.Group>
        {touched[name] && errors[name] && <div className="error">{errors[name]}</div>}
      </Form.Field>
    );
  }
}

export default RadioGroupField;
